import { Component } from '@angular/core';

/**
 * I18n Constants Component
 *
 * This component exists solely to mark reusable strings for i18n extraction.
 * It's never rendered or used in the app - just included in the build so that
 * ng extract-i18n can find these translations.
 *
 * Purpose:
 * - Centralized location for translations used in TypeScript (enums, constants, etc.)
 * - Ensures enum values, error messages, and dynamic strings are extracted to XLIFF
 * - Allows using translate.instant() anywhere in the app with these IDs
 *
 * Usage:
 * 1. Add i18n strings here with custom IDs (@@myId format)
 * 2. Run: npm run i18n:auto
 * 3. Use in TypeScript: this.translate.instant('myId')
 *
 * Note: This component is imported in app.config.ts to ensure it's included in extraction
 */
@Component({
  selector: 'i18n-constants',
  template: `
    <!-- ============================================ -->
    <!-- Group Detail Tabs (from GroupDetailTab enum) -->
    <!-- ============================================ -->
    <span i18n="@@groupDetailTabDetails">Details</span>
    <span i18n="@@groupDetailTabMembers">Members</span>
    <span i18n="@@groupDetailTabOwners">Owners</span>
    <span i18n="@@groupDetailTabPublish">Publish</span>
    <span i18n="@@groupDetailTabActivity">Activity</span>

    <!-- ============================================ -->
    <!-- Common Strings -->
    <!-- ============================================ -->
    <span i18n="@@search">Search</span>

    <!-- ============================================ -->
    <!-- Messages -->
    <!-- ============================================ -->
    <span i18n="@@searchArchived">Search archived</span>
  `,
  standalone: true
})
export class I18nConstantsComponent {}